export const initToggle = (column) => {
    column.getElement().querySelectorAll('[data-toggle="column"]').forEach((el) => {
        el.addEventListener('click', e => column.toggle());
        el.style.cursor = 'pointer';
    });
};
